export default __webpack_public_path__ + "img/a491ef96622da59e780271460ac70cb8.svg";